import { getToken } from 'firebase/app-check'
import { appCheck, initAppCheckIfNeeded } from './config'

// Force the App Check token to be minted before the next Firebase SDK call.
// Without this, the very first signInAnonymously / Firestore read on a cold
// page load can race the reCAPTCHA bootstrap and fly through unverified —
// the source of the ~7% unverified Auth requests in the Phase 0 baseline.
//
// Resolves to the token string on success, or null when App Check is disabled
// (no site key in env) or the provider call fails. Callers should treat null
// as "proceed without a token" rather than block the UI on an unrecoverable
// reCAPTCHA failure.
export async function ensureAppCheckToken() {
  initAppCheckIfNeeded()
  if (!appCheck) return null
  try {
    const result = await getToken(appCheck, /* forceRefresh */ false)
    return result?.token || null
  } catch (err) {
    console.warn('[appCheck] getToken failed:', err)
    return null
  }
}
